export const EVENT_TYPES = {
  BUTTON_CLICK: "button_click",
  LINK_CLICK: "link_click",
  PAGE_VIEW: "pv",
};

export const LOGOUT_TYPES = {
  CORE_PLATFORM: "core-platform",
  IMPERSONATION: "impersonation",
  SSO: "sso",
};

export const XAPI_EVENT_TYPES = {
  ARCHIVED: "archived",
  ASSIGNED: "assigned",
  ATTEMPTED: "attempted",
  AUTHENTICATED: "authenticated",
  COMPLETED: "completed",
  CREATED: "created",
  DELETED: "deleted",
  DOWNLOADED: "downloaded",
  EXPERIENCED: "experienced",
  EXPORTED: "exported",
  FILTERED: "filtered",
  RATED: "rated",
  REACTIVATED: "reactivated",
  RECEIVED: "received",
  SEARCHED: "searched",
  SELECTED: "selected",
  TOGGLED: "toggled",
  VIEWED: "viewed",
};

export const XAPI_OBJECT_TYPES = {
  ACCORDION: "accordion",
  ACCORDION_MENU: "accordion menu",
  ACTIVITY: "activity",
  BAR_CHART: "bar chart",
  BUTTON: "button",
  CHECKBOX: "checkbox",
  CLASSROOM: "classroom",
  CREDENTIAL: "credential",
  DASHBOARD_DATE: "dashboard date",
  DASHBOARD_METRIC_BUTTON: "dashboard metric button",
  DASHBOARD_PRODUCT: "dashboard product",
  DOWNLOAD: "download",
  FILTER: "filter",
  HYPERLINK: "hyperlink",
  MENU: "menu",
  PAGE: "page",
  PROGRAM: "program",
  SEARCH_BAR: "search bar",
  SESSION: "session",
  SIMPASS: "simpass",
  SIMULATION: "simulation",
  SIMULATION_STEP: "simulation step",
  STORYLINE_ACTIVITY: "storyline activity",
  STORYLINE_SLIDE: "storyline slide",
  TAB: "tab",
  USER: "user",
  WARNING: "warning",
};

export const XAPI_TARGET_TYPES = {
  CLASSROOM: "classroom",
  ORGANIZATION: "organization",
};

export const XAPI_NAV_NAMES = {
  CURRICULUM_PLANNER: "Curriculum Planner",
  VIEW_HEADSET_DEVICES: "View Headset Devices",
};
